import { CatalogBaseModel } from './CatalogBaseModel';

export class CatalogConsent extends CatalogBaseModel {
  static get entity() {
    return 'catalog-consents';
  }

  static fields() {
    return {
      id: this.uid(),
      name: this.string(''),
      description: this.string(''),
      created_at: this.attr(null),
      updated_at: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      /**
       * Get all active consents
       * GET /api/v1/consents/active
       */
      async fetchActive() {
        // Since the route is public, do not send Authorization header if token missing
        return this.get('/v1/consents/active', { save: false });
      },

      /**
       * Check if user has agreed to active consents
       * GET /api/v1/user-consent
       */
      async requestConsents() {
        return this.get('/v1/consents/request', { save: false });
      },

      /**
       * Submit user consents
       * POST /api/v1/consents
       */
      async submitConsents(consentIds) {
        return this.post('/v1/consents', { consent_ids: consentIds }, { save: false });
      }
    }
  };
}

export default CatalogConsent;
